import React from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";

import { getAppSelector } from "../App/state/selectors";
import { Loader } from "../../components/Loaders/Loader/Loader";
import { ROUTES_MAP } from "../../routes/constants";
import useFirstModulePath from "../../hooks/useFirstModulePath";
import "./MainPage.scss";

export const MainPage = () => {
    const { isLoading } = useSelector(getAppSelector);
    const firstModulePath = useFirstModulePath();

    if(isLoading) {
        return <Loader style={{ height: "100vh" }} />;
    }

    if(firstModulePath) {
        return <Redirect to={firstModulePath} />;
    } else {
        return <Redirect to={ROUTES_MAP.noPermissions.path} />;
    }
};
